import React from 'react'
import { Provider } from 'react-redux'
import MessengerCustomerChat from 'react-messenger-customer-chat'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store, persistor } from '../store'
import Routes from './_routes'

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Routes />
        <MessengerCustomerChat
          pageId="107400858076204"
          appId="722376921778613"
        />
      </PersistGate>
    </Provider>
  )
}

export default App
